import {
  Cached,
  Download,
  MiscellaneousServices,
  CalendarMonth,
} from "@mui/icons-material";
import {
  Badge,
  Box,
  FormControl,
  FormControlLabel,
  IconButton,
  Switch,
  Tooltip,
  Typography,
  useTheme,
  Chip,
} from "@mui/material";
import React from "react";
import moment from "moment";

function TableFeature({
  handleFilter,
  openCustomizer,
  refresh,
  exportHandler,
  handleOverDue,
  activeCard,
  totalOverdue,
  fromDate,
  toDate,
}) {
  const theme = useTheme();

  const newfromDate = moment(fromDate).format("DD-MM-YYYY");
  const newtoDate = moment(toDate).format("DD-MM-YYYY");

  return (
    <>
      <Box>
        {(activeCard === "Purchase Orders" ||
          activeCard === "Partial Orders") && (
          <>
            <FormControl
              sx={{
                ml: 1,
                mr: 1,
                backgroundColor: "#DDF4FF",
                borderRadius: 2,
                pl: 3,
                pt: 0.5,
                pb: 0.5,
                width: 160,
              }}
            >
              <Box>
                <Badge
                  badgeContent={totalOverdue}
                  color="primary"
                  sx={{
                    "& .MuiBadge-badge": {
                      fontSize: "10px",
                    },
                  }}
                ></Badge>
                <FormControlLabel
                  control={<Switch size="small" onChange={handleOverDue} />}
                  label={
                    <>
                      <Typography variant="p" ml="2px" fontSize="13px">
                        Over Due
                      </Typography>
                    </>
                  }
                  labelPlacement="start"
                  sx={{
                    color: "#1C76FF",
                  }}
                />
              </Box>
            </FormControl>
          </>
        )}
        <Chip
          size="small"
          sx={{
            color: "primary",
            ml: 1,
            mr: 1,
            backgroundColor: `${theme.palette.primary.light}`,
          }}
          label={newfromDate}
        ></Chip>
        <a
          style={{
            paddingLeft: "4px",
            paddingRight: "4px",
            fontSize: "14px",
          }}
        >
          To
        </a>
        <Chip
          size="small"
          label={newtoDate}
          sx={{
            color: "primary",
            ml: 1,
            mr: 1,
            backgroundColor: `${theme.palette.primary.light}`,
          }}
        ></Chip>

        {handleFilter && (
          <Tooltip title="Advanced Search">
            <IconButton
              id="filter-btn"
              color="primary"
              sx={{
                ml: 1,
                mr: 1,
                backgroundColor: `${theme.palette.primary.light}`,
              }}
              onClick={handleFilter}
            >
              <CalendarMonth sx={{ fontSize: "17px" }} />
            </IconButton>
          </Tooltip>
        )}
        {openCustomizer && (
          <Tooltip title="Customize Column">
            <IconButton
              color="warning"
              id="custom-table"
              sx={{
                ml: 1,
                mr: 1,
                backgroundColor: `${theme.palette.warning.light}`,
              }}
              onClick={openCustomizer}
            >
              <MiscellaneousServices sx={{ fontSize: "17px" }} />
            </IconButton>
          </Tooltip>
        )}
        {refresh && (
          <Tooltip title="Refresh">
            <IconButton
              color="success"
              id="refresh"
              sx={{
                ml: 1,
                mr: 1,
                backgroundColor: `${theme.palette.success.light}`,
              }}
              onClick={refresh}
            >
              <Cached sx={{ fontSize: "17px" }} />
            </IconButton>
          </Tooltip>
        )}
        {exportHandler && (
          <Tooltip title="Export in Excel">
            <IconButton
              color="info"
              id="export-data"
              sx={{
                ml: 1,
                mr: 1,
                backgroundColor: `${theme.palette.info.light}`,
              }}
              onClick={exportHandler}
            >
              <Download sx={{ fontSize: "17px" }} />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    </>
  );
}

export default TableFeature;
